import { tabCloser, tabTemplate, categoryCodeTab } from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import { closeNotifications } from '../actions';
import NotificationsActions from '../components/NotificationsActions';
import NotificationsPanel from '../components/NotificationsPanel';

export default (urls, access, entity = '') => ({
  ...tabTemplate('notifications', NotificationsPanel, matchSingleUrl([...urls, 'notifications']), NotificationsActions),
  ...tabCloser('closeNotificationsTab', closeNotifications),
  access,
  componentState: ({ args, url }) => categoryCodeTab(url, args[2], entity),
  dropDownIcon: 'bell outline',
  icon: 'far fa-bell',
  order: 295,
  position: 'bottom-right',
});
